<template>
  <vs-popup classContent="popup-example"  title="افزودن گارانتی جدید" :active.sync="showPopup">
    <div class="vx-col w-full mb-base" @keydown.enter="addWarrantyInfo()">
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-user"
            icon-no-border
            label-placeholder="نام خریدار (sms)"
            v-model="addWarranty.name"
          />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-phone"
            icon-no-border
            label-placeholder="موبایل (sms)"
            v-model="addWarranty.phone_number"
          />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-user"
            icon-no-border
            label-placeholder="نام خریدار/مجموعه"
            v-model="addWarranty.customer"
          />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-user"
            icon-no-border
            label-placeholder="شماره گارانتی"
            v-model="addWarranty.number"
          />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-user"
            icon-no-border
            label-placeholder="نوع سیستم"
            v-model="addWarranty.system_type"
          />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary is-label-placeholder">
            <div class="vs-con-input">
              <pdatepicker
                placeholder="تاریخ شروع گارانتی"
                header-background-color="#fb8103"
                hover-day-back-color="#fb8103"
                chosen-day-back-color="#fb8103"
                class="vs-inputx vs-input--input hasValue hasIcon"
                style="border : 1px solid rgba(0, 0, 0, 0.2)"
                v-model="addWarranty.start_date"
              ></pdatepicker>
              <i class="vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon feather icon-calendar null icon-no-border"></i>
            </div>
          </div>
          <span class="text-danger text-sm"></span>
        </div>

        <div class="vx-col w-full mt-4">
          <label class="vs-input--label">آدرس</label>
          <vs-textarea v-model="addWarranty.address" rows="4" />
        </div>

      </div>

      <vs-row class="mt-4" vs-w="12" vs-type="flex" vs-justify="center">
        <vs-col class="sm:w-1/2 w-full">

        </vs-col>
        <vs-col class="sm:w-1/2 w-full">
          <vs-button class="mr-3 float-right" @click="addWarrantyInfo()" :disabled="!validateForm">ثبت</vs-button>
        </vs-col>
      </vs-row>

    </div>
  </vs-popup>
</template>

<script>
export default {
  name: 'addWarranty',
  props: {
    popupAddWarranty: {
      type: Boolean,
      default: false,
    },
  },
  components: {},

  computed: {
    validateForm() {
      return this.addWarranty.customer != '' && this.addWarranty.number != '' && this.addWarranty.system_type != '' && this.addWarranty.start_date != '' && this.addWarranty.address != '';
    },
  },

  data() {
    return{
      showPopup: false,
      addWarranty: {
        customer: '',
        number: '',
        system_type: '',
        start_date: '',
        address: '',
        name: '',
        phone_number: ''
      },
    }
  },

  watch: {
    popupAddWarranty(newVal) {
      this.showPopup = newVal
    },

    showPopup(newVal) {
      this.$emit('updatePopupAddWarranty', newVal)
      this.addWarranty = {
        customer: '',
        number: '',
        system_type: '',
        address: '',
        start_date: '',
        name: '',
        phone_number: '',
      }
    },
  },

  methods: {
    addWarrantyInfo(){
      this.$vs.loading()
      this.$emit('updatePopupAddWarranty', false)
      let start_date = ''
      if(this.addWarranty.start_date != '') {
        start_date = this.addWarranty.start_date.replaceAll('/','-')
      }
      let warrenty = {
        customer : this.addWarranty.customer,
        number : this.addWarranty.number,
        system_type : this.addWarranty.system_type,
        address : this.addWarranty.address,
        start_date: start_date,
        name: this.addWarranty.name,
        phone_number: this.addWarranty.phone_number
      }
      this.addWarranty = {
        customer: '',
        number: '',
        system_type: '',
        address: '',
        start_date: '',
        name: '',
        phone_number: '',
      }
      this.$store.dispatch('addWarranty', warrenty)
      .then(() => {
        this.$vs.loading.close()
        this.$vs.notify({
          title: '',
          text: 'گارانتی با موفقیت افزوده شد.',
          iconPack: 'feather',
          icon: 'icon-check-square',
          color: 'success'
        })
      })
      .catch(() => {
        this.$vs.loading.close()
        this.$vs.notify({
          title: '',
          text: 'اطلاعات وارد شده صحیح نمی باشد.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
      })
    },
  }
}
</script>

<style>
.con-vs-popup .vs-popup {
    width: 80% !important;
}

.day-box:hover ,.month-box:hover ,.year-box:hover , .chosen-day, .chosen-month, .chosen-year{
    color: #fff!important;
}

.day-name:hover{
    color: #000!important;
}

.pdatepicker input{
	border: none!important;
	text-align: left!important;
	width: 115px!important;
}
</style>
